import AnalyticsHelper from '../utils/analytics-helper';

export default class Login {
    constructor(parent) {
        this.el = parent.el;
        this.myAccount = parent.myAccount;
        this.myAccount2 = parent.myAccount2;
        this.container = this.el.querySelector('.login-container');
        this.close = this.el.querySelector('.login-close');
        this.myAccount2Login = this.el.querySelector('.my-account-2-login');
        this.myAccount2Register = this.el.querySelector('.my-account-2-register');    
        if (this.container) {            
            this.bind();
            this.toggle();
        } 
    }

    bind() {
        this.close?.addEventListener('click', (e) => {
            e.preventDefault();
            this.container.classList.add('hide');
            AnalyticsHelper.push(this.close);
        });

        this.myAccount2Login?.addEventListener('click', (e) => {
            e.preventDefault();                
            this.myAccount2.showModal({ view: 'login' });
            AnalyticsHelper.push(this.myAccount2Login);
        });

        this.myAccount2Register?.addEventListener('click', (e) => {
            e.preventDefault();
            this.myAccount2.showModal({ view: 'login', tab: 'register' });
            AnalyticsHelper.push(this.myAccount2Register);
        });

        this.myAccount2?.addEventListener('login', () => this.toggle());
    }

    toggle() {
        if (this.myAccount?.isLoggedIn() || this.myAccount2?.isLoggedIn()) {
            this.container.classList.add('hide');
        } else {
            this.container.classList.remove('hide');
        }
    }
}
